import Box from '@mui/material/Box'
import * as React from 'react'
import {
  Grid,
  Link,
} from '@mui/material'
import SkeletonTableLoader from '../../../common/components/loaders/skeletonLoader'
import jwt_decode from 'jwt-decode'
import { useSearchParams } from 'react-router-dom'
import { downloadFileDoc } from '../../../api/orders/directRoutingAPI'
import { normalizeApiResponse } from '../../../helpers/HelperFunctions'



export default function ViewDoc(props) {
  const [loader, setLoader] = React.useState(false);
  const [searchParams] = useSearchParams();
  const [submitLoader, setSubmitLoader] = React.useState(false)


  // const downloadDocument = async () => {
  //   setSubmitLoader(true)
  //   const decodeToken = localStorage.getItem('sd_cp.jwt:tkn');
  //   const decoded = jwt_decode(decodeToken);

  //   const companyId = searchParams.get('company_id') || decoded?.company_id;

  //   try {
  //     const response = await downloadFileDoc({ companyId: companyId },
  //       { companyId: companyId, CustomerId: companyId }, companyId, props?.details,
  //     );
  //     if (response) {
  //       const url = window.URL.createObjectURL(new Blob([response.data]));
  //       const link = document.createElement("a");

  //       link.href = url;
  //       link.setAttribute("download", props?.details?.FileName); // filename
  //       document.body.appendChild(link);
  //       link.click();

  //       link.remove();
  //       window.URL.revokeObjectURL(url);
  //       setSubmitLoader(false)
  //     }
  //   } catch (error) {
  //     toast.showToast(normalizeApiResponse(error)?.message, 'error');
  //   } finally {
  //     setSubmitLoader(false)
  //   }
  // }

  return (
    <Box role="presentation">
      {loader ? (
        <div
          style={{
            padding: '5px 10px 0 20px',
          }}
        >
          <SkeletonTableLoader></SkeletonTableLoader>
        </div>
      ) : (
        <>
          <div
            style={{
              display: 'flex',
              width: '100%',
              justifyContent: 'space-between',
              padding: '5px 0 0 10px',
            }}
          >
            <div
              style={{ display: 'flex', position: 'absolute', right: '70px' }}
            >
            </div>
            <h2 style={{ fontSize: '14px', marginLeft: '10px' }}>
              <Grid container spacing={2}>
                <Grid item>
                  <label style={{ fontWeight: 'normal' }}>File Name:</label>
                </Grid>
                <Grid item>
                  <label>{props?.details?.fileName || 'NA'}</label>
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item>
                  <label style={{ fontWeight: 'normal' }}>File Type:</label>
                </Grid>
                <Grid item>
                  <label>{props?.details?.fileType || 'NA'}</label>
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item>
                  <label style={{ fontWeight: 'normal' }}>File Description:</label>
                </Grid>
                <Grid item>
                  <label>{props?.details?.description || 'NA'}</label>
                </Grid>
              </Grid>

              <Grid container spacing={2}>
                <Grid item>
                  <Link onClick={() => props.download(props?.details)}>Download</Link>
                </Grid>
              </Grid>
            </h2>
          </div>
        </>
      )}
    </Box>
  )
}
